import {
  Dataset,
  DatasetControl,
  MethodControlAction,
} from '../../../types/types';
import { getDataKey } from '../../../utils/getDataKey';
import { DatasetControlMethodActionApiRequestData } from '../../types/types';

export const getDatasetControlMethodActionApiRequestData = (
  dataset: Dataset,
  control: DatasetControl,
  token: string | null,
  currentRow: any | undefined,
  rowsToUse: any[],
  cachedQueryId?: string | null
): DatasetControlMethodActionApiRequestData => {
  const dataKey = getDataKey(dataset);
  const ids = rowsToUse.map((row) => row[dataKey]);
  const params = (control.action as MethodControlAction)?.params?.map(
    ({ key, value }) => [key, String(value)]
  );

  // Fall back to the single selected row when no row is expanded, so id/row stay
  // filled for selection-only actions (mirrors navigateToForm's rowsToUse[0]).
  const targetRow =
    currentRow ?? (rowsToUse.length === 1 ? rowsToUse[0] : undefined);

  return {
    datasetId: dataset.datasetId,
    sessionId: token || '',
    ...(cachedQueryId !== undefined ? { cachedQueryId } : {}),
    id: targetRow ? targetRow[dataKey] : undefined,
    row: targetRow ? targetRow : undefined,
    ids,
    idItem: dataKey,
    params: params ? Object.fromEntries(params) : undefined,
  };
};
